import { schema } from 'prose-core'
import { NodeSelection } from 'prosemirror-state'
import { type EditorView } from 'prosemirror-view'
import { TableOfContentsFormattingAttributes } from './types'

export function cleanupTableOfContentsFormatting(view: EditorView) {
  const {
    state: { tr, selection },
    dispatch,
  } = view
  if (selection instanceof NodeSelection && selection.node.type === schema.nodes.table_of_contents) {
    const attributes: TableOfContentsFormattingAttributes = {
      boxColor: null,
      fontColor: null,
      highlightColor: null,
      fontFamily: null,
      fontWeight: null,
      fontSize: null,
    }
    dispatch(tr.setNodeMarkup(selection.$from.pos, undefined, attributes))
  }
}
